import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';
import { isSchedulingStaff } from '@/lib/product-flags';

/**
 * Route guard that ensures the user is a participant.
 * Must be nested inside a ProtectedRoute (assumes user is authenticated).
 * Redirects admin and QA to their respective dashboards.
 */
export function ParticipantRoute() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" />
      </div>
    );
  }

  if (user?.role === 'super_admin' || user?.role === 'admin' || user?.role === 'project_manager') {
    return <Navigate to="/admin/dashboard" replace />;
  }

  if (isSchedulingStaff(user)) return <Navigate to="/scheduling" replace />;

  if (user?.role === 'qa') {
    return <Navigate to="/qa/dashboard" replace />;
  }

  return <Outlet />;
}
